import { Img } from '@superhi/design'

type Props = { url?: string }

const ImagePreview: React.FC<React.PropsWithChildren<Props>> = ({ url }) => <Img src={url || ''} />

export default ImagePreview
